// extracted by mini-css-extract-plugin
export default {"products":"Dr-z","card":"Er-z","oosMessaging":"Fr-z"};